/**
 * @name getFormattedMessages
 * @desc Takes in a message string and returns it in a GBO message array format
 * @param {String} message
 * @param {Object} [exception]
 * @param {String} axiosErrorCode
 * @returns {Array}
 * @memberof utils
 * @example
 * const messages = utils.getFormattedMessages('hello world!');
 * console.log(messages); // [{ priority: 'ERROR', display_as: '', message:'hello world!', exception: 'exception error', code: "ERR_NETWORK" }]
 */
export function getFormattedMessages(message, exception, axiosErrorCode) {
  return [{ priority: 'ERROR', display_as: '', message, exception, code: axiosErrorCode}];
} 
